import React from 'react';

const PrivacyPolicyPageHeader = () => (
  <div className="margin-top-10 margin-bottom-10">
    <div className="container text-center">
      <div className="row">
        <div className="col-xs-12 margin-top-sm-40 margin-top-xs-20 text-size-sm-72 text-size-xs-36 text-weight-black margin-top-60 text-align-center line-height-full text-color-blue">
          PRIVACY POLICY
        </div>
      </div>
      <div className="row">
        <div className="col-sm-10 col-sm-offset-1 text-color-dark-slate text-size-xs-12 text-size-sm-14 text-weight-book padding-top-40 padding-bottom-30 text-align-center">
          Please read the following policy to understand how your personal information will be treated as you make use of our services. This policy may change from time to time so please check back periodically.
        </div>
      </div>
    </div>
  </div>
);

export default PrivacyPolicyPageHeader;
